import MemoryGame from "./MemoryGame";

export default MemoryGame;
